import ReactGA from "react-ga4";
import {environment} from "config";

const TRACKING_ID = environment.googleAnalyticsId;
ReactGA.initialize(TRACKING_ID);

export default ReactGA;
